import { z } from 'zod';

export const imageWithMetadata = z.object({
  data: z.string(),
  width: z.number(),
  height: z.number(),
  aspectRatio: z.number(),
});

export type ImageWithMetadata = {
  data: string;
  width: number;
  height: number;
  aspectRatio: number;
};

export const getImageInfoFromBase64 = async (
  base64Image: string
): Promise<ImageWithMetadata> => {
  const dimensions = await getDimensionsFromBase64(base64Image);
  return {
    ...dimensions,
    aspectRatio: dimensions.width / dimensions.height,
    data: base64Image,
  };
};

export const resizeToWidth = (
  originalImage: ImageWithMetadata,
  width: number,
  maxHeight?: number
): ImageWithMetadata => {
  const height = width / originalImage.aspectRatio;
  if (maxHeight && height > maxHeight) {
    return resizeToHeight(originalImage, maxHeight);
  }

  return {
    ...originalImage,
    width,
    height,
  };
};

export const resizeToHeight = (
  originalImage: ImageWithMetadata,
  height: number,
  maxWidth?: number
): ImageWithMetadata => {
  const width = height * originalImage.aspectRatio;

  if (maxWidth && width > maxWidth) {
    return resizeToWidth(originalImage, maxWidth);
  }

  return {
    ...originalImage,
    width,
    height,
  };
};

const getDimensionsFromBase64 = (base64: string) => {
  return new Promise<{ width: number; height: number }>((resolve, reject) => {
    const img = new Image();
    img.addEventListener('load', () => {
      resolve({
        width: img.width,
        height: img.height,
      });
    });
    img.addEventListener('error', reject);
    img.src = base64;
  });
};
